import React from 'react';

export default function FeedbackBullets() {
  return (
    <ul className="vertical-margin">
      <li className="vertical-margin">Send feedback for Toastmasters speeches anonymously to your phone (US only)</li>
      <li className="vertical-margin">Full paperless support for hybrid meetings as well (via QR code support)</li>
      <li className="vertical-margin">We do not store any data; this is a private, anonymous service</li>
    </ul>
  );
}
